/* One carrier of `shipping-labels-carriers?fulfillment_provider_id=`. */
export type ProviderCarrier = {
  _id: number;
  provider: { name: string; value: string };
  primary?: boolean;
  manual?: boolean;
  credentials?: unknown;
  total_services?: number;
  total_packages?: number;
  existing_fields?: Record<string, { key: string; value: string }>;
};

/** The saved credential fields shown under the carrier's name. */
export function credentialFields(carrier: ProviderCarrier) {
  return Object.entries(carrier.existing_fields ?? {}).map(([id, field]) => ({
    id,
    ...field,
  }));
}
